export const getPageSizeStyle = (pageSize) => {
  switch (pageSize) {
    case 2:
      return 'width: 100%; height: auto;'
    default:
      return 'width: 100%; height: 100%;'
  }
}

export const getItemStyle = (obj) => {
  var style = ''
  style += obj.size_type + ': ' + obj.size_value + ';'
  if (obj.position !== 'auto') {
    style += 'position: ' + obj.position + ';'
    style += obj.y_axis_type + ': ' + obj.y_axis_value + ';'
    style += obj.x_axis_type + ': ' + obj.x_axis_value + ';'
  }
  if (obj.margin !== 'margin') {
    style += 'margin: ' + obj.margin + ';'
  }
  if (obj.padding !== 'padding') {
    style += 'padding: ' + obj.padding + ';'
  }
  if (obj.style) {
    style += obj.style
  }
  return style
}

export const getSimulatorBodyStyle = (background) => {
  var ret = ''
  if (background.color) {
    ret += 'background-color: #' + background.color + ';'
  }
  if (background.font_color) {
    ret += 'color: #' + background.font_color + ';'
  }
  if (background.image) {
    ret += 'background-image: url(' + background.image + ');'
  }
  if (background.image_repeat) {
    ret += 'background-repeat: ' + background.image_repeat + ';'
  }
  if (background.image_position) {
    ret += 'background-position: ' + background.image_position + ';'
  }
  if (background.image_size) {
    ret += 'background-size: ' + background.image_size + ';'
  }
  return ret
}

export const getSimulatorBodyItem = (obj) => {
  var html = ''
  if (obj.image) {
    html += '<div style="padding-top: ' + obj.top + '; padding-bottom: ' + obj.bottom + '; padding-left: ' + obj.left + '; padding-right: ' + obj.right + ';text-align: ' + obj.image_align + ';">'
    html += '<img src="' + obj.image + '" style="width: ' + obj.image_width + ';">'
    html += '</div>'
  }
  return html
}



// WEBPACK FOOTER //
// ./src/libs/tool.js